<template>
  <template v-if="question?.status !== 'READ_ONLY'">
    <div class="inputContainer form-group mb-1 " :class="{ 'border-setup': !hasBeenInteractedWith,}">
      <div class="d-flex w-100 align-items-end" :class="{
            'invalid': vgsFieldState?.[fieldSettings.name]?.isTouched && vgsFieldState?.[fieldSettings.name]?.errorMessages?.length
            }">
        <div
            :id="question.name"
            v-bind="$attrs"
            :class="{
            'invalid': vgsFieldState?.[fieldSettings.name]?.isTouched && vgsFieldState?.[fieldSettings.name]?.errorMessages?.length
            }"
            class="choice quill-question-input flex-grow-1 ps-3"
            :style="{
              outline:'none',
            }"
            ></div>
      </div>
      <span class="quill-question-placeholder placeholder-wrap" :class="{'placeholder-adjusment':vgsFieldState?.[fieldSettings.name]?.isFocused || !vgsFieldState?.[fieldSettings.name]?.isEmpty,}"
      >
      {{ forcePromptPlaceholder ? question.prompt : question.placeholder }}
    </span>

    </div>
    <slot name="helptext" :isConfirm="!disableConfirm && (question?.value && question?.prefilled) && !vgsFieldState?.[fieldSettings.name]?.errorMessages.join('. ')" :isError="vgsFieldState?.[fieldSettings.name]?.isTouched ? displayErrorMessages:''"
          :confirmCb="() =>{$emit('user-interaction'); $emit('confirm'); }"></slot>

  </template>

</template>

<script>
import {toRaw} from "vue";
import {debounce} from "@/components/waffle/utils/debouce";

const cardIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='12' fill='currentColor' class='bi bi-credit-card' viewBox='0 0 16 16'%3E%3Cpath d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z'/%3E%3Cpath d='M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a11 0 0 1-1-1v-1z'/%3E %3C/svg%3E";

export default {
  props: [
    'question',
    'index',
    'isVgsFormReady',
    'vgsFieldObject',
    'vgsFieldState',
    'disableConfirm',
    'forcePromptPlaceholder'
  ],
  emits:['loadVgsField','remove-field', 'user-interaction','confirm'],
  data() {
    return {
      error: '',
      vgsName: this.question.name,
      fieldSettings: this.makeConfig(this.question)
    };
  },
  setup(props, context) {
    const emitLoad = debounce(function (question, fieldSettings) {
      context.emit('loadVgsField', {
        question,
        targetId:toRaw(`#${question.name}`),
        fieldSettings:toRaw(fieldSettings),
        vgsName:toRaw(fieldSettings.name)
      });
    }, 250)
    return {
      emitLoad
    }
  },
  mounted() {
    if (this.question.error) {
      this.error = this.question.error
    }

    if(this.isVgsFormReady && this.question.status === 'EDITABLE'){
      this.$nextTick(() => {
        this.emitLoad(this.question, this.fieldSettings)
      })
    }
  },
  methods:{
    makeConfig(question){
      const criteria = question.criteria.find(el => typeof el === 'object')
      const config = {
        type: this.question.type?.split('vgs-')?.[1] ?? 'text',
        name: `fields[${this.index}].field_value`,
        successColor: '#212121',
        errorColor: '#BB0000',
        inputMode:'numeric',
        serializers: [{ name: 'replace', options: { old:' / ', new:'' }},{ name: 'replace', options: { old:' ', new:'' }},],
        validations: ['required'],
        css: {
          height: '20px',
          bottom:7,
          fontWeight:'bold',
          fontSize:'16px',
          fontFamily:'Roboto,sans-serif',
          'margin-top':'auto',
          '&::-webkit-outer-spin-button': {'-webkit-appearance': 'none', margin: 0},
          '&::-webkit-inner-spin-button': {'-webkit-appearance': 'none', margin: 0},
          '&.invalid.touched:not(:focus)': {
            'color': 'red',
          },
          '&.invalid:focus':{
            'color':'#212121 !important'
          }

        },
      }

      if(criteria?.validation){
        config.validations.push(criteria.validation)
      }

      if(!Number.isNaN(criteria?.min)){
        config.min = criteria.min
      }

      if(!Number.isNaN(criteria?.max)){
        config.max = criteria.max
      }

      if(!Number.isNaN(criteria?.maxLength)){
        config.maxLength = criteria?.maxLength;
      }

      if(!this.question.type.includes('text')){
        config.showCardIcon = {
          bottom: 0,
          right:12,
          transform: 'translateY(-50%)'
        }
        config.icons={
          cardPlaceholder:cardIcon
        }
      }
      return config
    },
  },
  watch: {
    vgsFieldState(val){
      if(val?.[this.fieldSettings.name]?.isTouched){
        this.$emit('user-interaction', true)
      }
    },
    "isVgsFormReady": function (newValue) {
      if (newValue === true && this.question.status === 'EDITABLE') {
        this.fieldSettings = this.makeConfig(this.question)
        this.$nextTick(() => {
          this.emitLoad(this.question, this.fieldSettings)
        })

      }
    },
    question:{
      handler:function(newQuestion){
        if(newQuestion.status === 'EDITABLE'){
          this.fieldSettings = this.makeConfig(newQuestion)
          this.$nextTick(() => {
            this.emitLoad(this.question, this.fieldSettings)
          })
        }
      },
      deep: true
    }
  },
  computed:{
    errorMessagesMapping(){
      return this.question?.criteria?.find(el => typeof el === "object")?.errorMessageMappings ?? {}
    },
    displayErrorMessages(){
      const errors = this.vgsFieldState?.[this.fieldSettings.name]?.errors
      const usedCodes = {}
      return errors.reduce((acc, curr) => {
        if(curr.code === 1001) {
          usedCodes[1001] = true
          acc += 'Required.';
        }
        else if(!usedCodes[curr.code]){
          usedCodes[curr.code] = true
          acc += ' ' + (this.errorMessagesMapping[curr.code] ? this.errorMessagesMapping[curr.code] : curr.message);
        }
        return acc
      }, '')
    }
  },
  unmounted() {
    this.$emit('remove-field', this.fieldSettings.name)
  }
};

</script>


<style scoped lang="scss">
.invalidBtn{
  border-bottom-color: transparent !important;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
}


.align-text-end {
  text-align: end;
}

.subtext {
  font-size: .75rem;
  font: normal normal normal 12px/18px Roboto;
  letter-spacing: 0px;
  margin-bottom: 4px;
  color: #757575
}

.errorMessage {
  color: #BB0000
}

.gap {
  margin-right: 10px;
}

.quill-question {

  > div.inputContainer {
    position: relative;
    max-height: 50px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    cursor: pointer;

    > div{
      border: 1px solid #ccc;
      border-radius: 3px;
      &:hover:not(.invalid), &:focus:not(.invalid), &:focus-within:not(.invalid) ,&:focus-visible:not(.invalid) {
        border-color:#212121;
        box-shadow: 0 0 0 1px #212121 !important;
        border-radius: 3px;
      }
    }


    > div >.quill-question-input {
      box-sizing: border-box;
      border: none;
      width: 100%;
      font-size: 16px;
      font-weight: bold;
      background: transparent;
      min-height: 100%;
      max-height: 100%;
      @media screen and (max-width: 768px) {
        min-width: auto !important;
        // flex: 0 0 45% !important;
      }

      &:has(~.question-type-unknown) {
        border-color: #BB0000;
      }

      &:hover:not(.invalid), &:focus:not(.invalid), &:focus-within:not(.invalid) ,&:focus-visible:not(.invalid) {
        outline: none;
        box-shadow: none;
      }

      &:disabled {
        background-color: #EEEEEE;
      }

    }

    > div + .quill-question-placeholder {
      position: absolute;
      padding: 10px 12px;
      line-height: 2em;
      top: 0;
      left: 0;
      color: #757575;
      font-size: 16px;
      pointer-events: none;
      transform: scale(1);
      transition: .26s all ease;
    }
  }
}

/*TODO convert to scss*/



.placeholder-adjusment.quill-question-placeholder {
  font-size: 12px !important;
  padding-top:6px !important;
  padding-right: 8px !important;
  padding-bottom:12px !important;
  padding-left:12px ;
}


.form-floating > .form-control:focus ~ label.form-label-text, .form-floating > .form-control:focus ~ label {
  font-size: 12px;
  color: #484848;
  padding-top: 1rem;
}

.form-control-disabled:hover {
  border: none;
}

.form-control-enabled:hover {
  border-color:#212121;
  box-shadow: 0 0 0 1px #212121 !important;
}

.invalid:not(.quill-question-input) {
  border: 1px solid #BB0000 !important;
  border-radius: 3px;

  &:hover, &:focus, &:focus-within {
    border-color:#BB0000;
    box-shadow: 0 0 0 1px #BB0000 !important;
  }
}
</style>

<style>
.vgs-field {
  width: 100%;
  margin-top: -3px;
}
</style>

<style scoped>
IFRAME {
  width: 100%;
  max-height: 50px;
}
</style>
